/**
 * Escurece uma cor hexadecimal aproximando-a do preto.
 * Usado nos estados de hover, para que cada cor de solução tenha o seu
 * próprio tom mais escuro em vez de trocar para outra cor da paleta.
 */
export const darken = (hex: string, amount = 0.15): string => {
  const value = hex.replace('#', '');
  const full = value.length === 3 ? value.replace(/./g, (c) => c + c) : value;
  const num = parseInt(full, 16);

  const channel = (shift: number) =>
    Math.round(((num >> shift) & 0xff) * (1 - amount))
      .toString(16)
      .padStart(2, '0');

  return `#${channel(16)}${channel(8)}${channel(0)}`;
};
